<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SubscriptionServiceItem",
  props: {
    service: Object
  },
  computed: {
    ...mapGetters('subscription', ['isChecked', 'getDuration', 'getSlots', 'getItems', 'isItemPresented', 'getBusySlots', 'getDiscount']),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE'])
  },
  methods: {
    ...mapActions('subscription', ['toggleService', 'setDuration', 'setSlots', 'showModal', 'toggleItemSlot']),
    showDialog(service_id) {
      this.$emit('showDialogModal', service_id)
    }
  }
}
</script>

<template>
  <li class="ais24--services__item">
    <div class="ais24--service-card">
      <div class="ais24--service-card__header">
        <div class="ais24--service-card-preview">
          <div class="ais24--service-card-preview__headline">
            <h3 class="ais24--service-card-preview__title">{{ service.name }}</h3>
            <p class="ais24--service-card-preview__caption">{{ service.description }}</p>
          </div>
          <div class="ais24--service-card-preview__status">
            <div class="ais24--field-switch">
              <label class="ais24--field-switch__label">
                <input class="ais24--field-switch__input" type="checkbox" value="1" :checked="isChecked(service.id)"
                       @click="toggleService(service)"/>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="ais24--service-card__body">
        <div class="ais24--service-card-settings">
          <ul class="ais24--service-card-settings__list">
            <li class="ais24--service-card-settings__item">
              <div class="ais24--service-card-settings__headline">
                <div class="ais24--service-card-settings__title">Выберите период</div>
                <div class="ais24--service-card-settings__info"></div>
              </div>
              <div class="ais24--service-card-settings__details">
                <div class="ais24--service-card-settings__title">{{ getDuration(service.id) }} месяцев</div>
                <div class="ais24--service-card-settings__info"></div>
              </div>
              <div class="ais24--service-card-settings__form">
                <div class="ais24--field-counter">
                  <button class="ais24--button ais24--button--default ais24--button--medium" type="button"
                          :disabled="getDuration(service.id) < 2"
                          @click="setDuration({service_id: service.id, period: getDuration(service.id) - 1})">
                    <svg class="ais24--icon ais24--icon--24x24">
                      <use xlink:href="/img/sprite.svg#icon-24-minus"></use>
                    </svg>
                  </button>
                  <div class="ais24--field-counter__value">
                    <output class="ais24--field-counter__output">{{ getDuration(service.id) }} мес.</output>
                    <span class="ais24--field-counter__label">{{ getDiscount(service.id) }}% скидка</span>
                  </div>
                  <button class="ais24--button ais24--button--primary ais24--button--medium" type="button"
                          @click="setDuration({service_id: service.id, period: getDuration(service.id) + 1})">
                    <svg class="ais24--icon ais24--icon--24x24">
                      <use xlink:href="/img/sprite.svg#icon-24-plus"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </li>
            <li class="ais24--service-card-settings__item">
              <div class="ais24--service-card-settings__headline">
                <div class="ais24--service-card-settings__title">Выберите организации</div>
                <div class="ais24--service-card-settings__info">{{ service.price_per_unit }} руб/месяц за место</div>
              </div>
              <div class="ais24--service-card-settings__details">
                <div class="ais24--service-card-settings__title">{{ getBusySlots(service.id) }} из
                  {{ getSlots(service.id) }} мест
                </div>
                <div class="ais24--service-card-settings__info"></div>
              </div>
              <div class="ais24--service-card-settings__form">
                <div class="ais24--field-counter">
                  <button class="ais24--button ais24--button--default ais24--button--medium" type="button"
                          :disabled="getSlots(service.id) < 2"
                          @click="setSlots({service_id: service.id, slots: getSlots(service.id) - 1})">
                    <svg class="ais24--icon ais24--icon--24x24">
                      <use xlink:href="/img/sprite.svg#icon-24-minus"></use>
                    </svg>
                  </button>
                  <div class="ais24--field-counter__value">
                    <output class="ais24--field-counter__output">{{ getSlots(service.id) }} мест</output>
                    <span class="ais24--field-counter__label"></span>
                  </div>
                  <button class="ais24--button ais24--button--primary ais24--button--medium" type="button"
                          @click="setSlots({service_id: service.id, slots: getSlots(service.id) + 1})">
                    <svg class="ais24--icon ais24--icon--24x24">
                      <use xlink:href="/img/sprite.svg#icon-24-plus"></use>
                    </svg>
                  </button>
                </div>
                <button class="ais24--button ais24--button--primary ais24--button--medium" type="button"
                        @click="showDialog(service.id)">
                  <span class="ais24--button__text">Настроить</span>
                </button>
              </div>

              <div class="ais24--service-card-settings__organizations">
                <div class="ais24--chips">
                  <ul class="ais24--chips__list">
                    <li class="ais24--chips__item" v-for="item in getItems(service.id)" v-bind:key="item.id">
                      <div class="ais24--chips__title">{{ item.name }}</div>
                      <button class="ais24--chips__button" type="button"
                              @click="toggleItemSlot({slot: item, service_id: service.id})">
                        <svg class="ais24--icon ais24--icon--20x20">
                          <use xlink:href="/img/sprite.svg#icon-20-cross"></use>
                        </svg>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

            </li>
          </ul>
        </div>
      </div>
    </div><!--/.ais24--service-card-->
  </li><!--/.ais24--services__item-->
</template>

<style scoped lang="scss">

</style>
